import { instance } from "api/apiBase";

interface AffordableHousingComConnectionResponse {
  connected: boolean;
}

interface AffordableHousingComStatusResponse extends AffordableHousingComConnectionResponse {
  leads_this_month: number;
  lead_limit: number;
  limit_reached: boolean;
  /** Calendar date (YYYY-MM-DD) the monthly count resets, in Central time. */
  resets_on: string;
}

const BASE_ENDPOINT_URL =
  "/portal/v1/external_integrations/affordable_housing_com";

export const affordableHousingComApi = {
  getStatus: async (): Promise<AffordableHousingComStatusResponse> => {
    const { data } =
      await instance.get<AffordableHousingComStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  connect: async (): Promise<AffordableHousingComConnectionResponse> => {
    const { data } =
      await instance.post<AffordableHousingComConnectionResponse>(
        BASE_ENDPOINT_URL
      );
    return data;
  },

  disconnect: async (): Promise<AffordableHousingComConnectionResponse> => {
    const { data } =
      await instance.delete<AffordableHousingComConnectionResponse>(
        BASE_ENDPOINT_URL
      );
    return data;
  }
};
